<template>
  <v-dialog v-model="dialog" fullscreen scrollable :retain-focus="false" persistent>
    <v-card class="dialog-card" elevation="6">
      <div class="hero">
        <div class="hero-content">
          <div class="d-flex align-center">
            <v-btn icon small class="mr-2" @click="cerrar" title="Cerrar">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <div class="d-flex flex-column">
              <span >
                <span class="title">
                  Solicitud - {{ solicitudData?.codigo || '-' }}
                </span>

                <v-chip class="ml-3" small color="indigo lighten-5" text-color="indigo darken-2">
                  MOD {{ moduloNumero }}
                </v-chip>
                <span>
                  {{moduloNombre || 'SIN MÓDULO' }}
                </span>
              </span>
              <small class="muted">
                <v-chip class="ml-3" small color="indigo lighten-5" text-color="indigo darken-2">
                  {{ programaCodigo|| 'SIN CODIGO' }}
                </v-chip>
                <span>
                  {{programaNombre|| 'SIN PROGRAMA' }}
                </span>
              </small>
            </div>
          </div>
          <div class="d-flex align-center">
            <v-chip
              class="ml-2"
              small
              outlined
              :color="estadoColor"
              :text-color="estadoColor">
              {{ estadoLabel }}
            </v-chip>
          </div>
        </div>
      </div>

      <v-card-text class="pt-4 body-wrapper">
        <v-row dense class="info-grid">
          <v-col v-for="card in cards" :key="card.key" cols="12" sm="6" md="4" lg="3">
            <v-card class="stat-card" outlined>
              <div class="stat-icon" :class="card.iconColor">
                <v-icon>{{ card.icon }}</v-icon>
              </div>
              <div class="stat-content">
                <div class="stat-label">{{ card.label }}</div>
                <div class="stat-value">{{ card.value }}</div>
                <small v-if="card.helper" class="muted">{{ card.helper }}</small>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- <v-row dense>
          <v-col cols="12" md="6">
            <v-card class="text-card" outlined>
              <div class="text-card__title">Motivo</div>
              <p class="text-card__body">{{ solicitudData?.motivo || 'Sin motivo registrado' }}</p>
            </v-card>
          </v-col>

          <v-col cols="12" md="6"  v-if="observar">
            <v-card class="text-card" outlined>
              <div class="text-card__title">Observaciones</div>
              <p class="text-card__body">{{ solicitudData?.observaciones || 'Sin observación' }}</p>
            </v-card>
          </v-col>
        </v-row> -->

        <v-card class="pdf-card" outlined>
          <div class="pdf-card__header">
            <div class="text-card__title mb-0">Solicitud en PDF</div>
            <v-btn small text color="primary" :loading="cargandoPdf" @click="cargarSolicitudPDF">
              <v-icon left small>mdi-refresh</v-icon>
              Recargar PDF
            </v-btn>
          </div>

          <div class="pdf-card__body">
            <v-skeleton-loader v-if="cargandoPdf" type="image" class="pdf-skeleton" tile />

            <v-alert v-else-if="pdfError" type="error" dense outlined>{{ pdfError }}</v-alert>

            <div v-else-if="pdfUrl" class="pdf-frame-wrapper">
              <iframe :src="pdfUrl" title="Solicitud PDF" width="100%" height="100%" />
            </div>

            <div v-else class="muted">Sin PDF disponible</div>
          </div>
        </v-card>
        <div class="">          
          <v-textarea
          v-model="observacion"
          outlined
          dense
          :disabled="observar"
          auto-grow
          rows="3"
          label="Observación"
          class="mt-3"
        />
        </div>
      </v-card-text>

      <v-card-actions class="pb-4 px-4">
        <v-spacer></v-spacer>

        <v-btn small  color="success" @click="confirmarRevisar('aprobada')" v-if="!observar">APROBAR</v-btn>
        <v-btn small color="error" @click="confirmarRevisar('rechazada')" v-if="!observar">RECHAZAR</v-btn>
        <v-btn small  color="warning" @click="confirmarRevisar('observado')" v-if="!observar">OBSERVAR</v-btn>
        <v-btn small text color="primary" @click="cerrar">Cerrar</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog
      v-model="confirmacionDialog.abierto"
      max-width="420"
      persistent
      :close-on-esc="false"
      :close-on-overlay-click="false"
    >
      <v-card class="confirm-card">
        <div class="confirm-card__header">
          <div class="confirm-card__icon" :class="confirmacionDialog.colorClass">
            <v-icon>{{ confirmacionDialog.icono }}</v-icon>
          </div>
          <div>
            <div class="confirm-card__title">Confirmar acción</div>
            <div class="confirm-card__subtitle">Esta acción actualizará el estado de la solicitud.</div>
          </div>
        </div>

        <v-card-text class="confirm-card__body">
          ¿Está seguro de {{ confirmacionDialog.accionLabel }} la solicitud?
        </v-card-text>

        <v-card-actions class="confirm-card__actions">
          <v-btn text color="grey" @click="confirmacionDialog.abierto = false">Cancelar</v-btn>
          <v-btn depressed color="primary" :class="confirmacionDialog.colorClass" @click="ejecutarRevisionConfirmada">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import solicitudModificacionCalificacionService from '../../../services/solicitud-modificacion-calificacion.service';
import {
  ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION,
  ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_COLORES,
  ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS,
} from '../../../utils/constantes';
import { formatearFechaHoraBolivia } from '../../../utils/funciones';

export default {
  name: 'DialogVerSolicitud',
  data() {
    return {
      dialog: false,
      solicitudData: null,
      pdfUrl: null,
      cargandoPdf: false,
      pdfError: null,
      observacion: this.solicitudData?.motivo || '',
      confirmacionDialog: {
        abierto: false,
        estado: null,
        accionLabel: '',
        colorClass: '',
        icono: 'mdi-help-circle-outline',
      },
      tiposSolicitud: {
        '0': 'Primera instancia',
        '1': 'Segunda instancia',
      },
    };
  },
  computed: {
    cards() {
      return [
        // {
        //   key: 'programa',
        //   label: 'Programa',
        //   value: this.programaNombre,
        //   helper: this.programaCodigo ? `Código ${this.programaCodigo}` : '',
        //   icon: 'mdi-school-outline',
        //   iconColor: 'icon-purple',
        // },
        // {
        //   key: 'modulo',
        //   label: 'Módulo',
        //   value: this.moduloNombre,
        //   helper: this.moduloNumero ? `N° ${this.moduloNumero}` : '',
        //   icon: 'mdi-view-module',
        //   iconColor: 'icon-purple',
        // },
        // {
        //   key: 'solicitante',
        //   label: 'Solicitante',
        //   value: this.solicitanteNombre,
        //   helper: this.solicitanteCi ? `CI: ${this.solicitanteCi}` : '',
        //   icon: 'mdi-account-circle-outline',
        //   iconColor: 'icon-purple',
        // },
        // {
        //   key: 'revisor',
        //   label: 'Revisor',
        //   value: this.revisorNombre,
        //   helper: this.revisorCi ? `CI: ${this.revisorCi}` : '',
        //   icon: 'mdi-account-check-outline',
        //   iconColor: 'icon-purple',
        // },
        // {
        //   key: 'fecha',
        //   label: 'Fecha solicitud',
        //   value: this.fechaSolicitud,
        //   helper: '',
        //   icon: 'mdi-calendar-month-outline',
        //   iconColor: 'icon-purple',
        // },
        // {
        //   key: 'tipo',
        //   label: 'Tipo de solicitud',
        //   value: this.tipoLabel,
        //   helper: '',
        //   icon: 'mdi-clipboard-text-outline',
        //   iconColor: 'icon-purple',
        // },
        // {
        //   key: 'estado',
        //   label: 'Estado interno',
        //   value: this.solicitudData?.estado || '-',
        //   helper: '',
        //   icon: 'mdi-flag-outline',
        //   iconColor: 'icon-purple',
        // },
      ];
    },
    // this.observacion=this.solicitudData?.motivo || '',
    estadoLabel() {
      const estado = this.solicitudData?.estadoSolicitud || this.solicitudData?.estado;
      return ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[estado] || estado || '';
    },
    observar(){
      const estado = this.solicitudData?.estadoSolicitud || this.solicitudData?.estado;

      return estado !== ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.PENDIENTE;
    },
    estadoColor() {
      const estado = this.solicitudData?.estadoSolicitud || this.solicitudData?.estado;
      return ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_COLORES[estado] || 'grey';
    },
    programaNombre() {
      return this.solicitudData?.programa?.nombreCompuesto || this.solicitudData?.programa?.nombre || '-';
    },
    programaCodigo() {
      return this.solicitudData?.programa?.codigo || '-';
    },
    moduloNombre() {
      return this.solicitudData?.programaModulo?.moduloNombre || '-';
    },
    moduloNumero() {
      return this.solicitudData?.programaModulo?.numero;
    },
    solicitanteNombre() {
      return this.solicitudData?.solicitante?.nombreCompleto || '-';
    },
    solicitanteCi() {
      return this.solicitudData?.solicitante?.nroCi || '-';
    },
    revisorNombre() {
      return this.solicitudData?.revisandoPor?.nombreCompleto || 'No se revisó';
    },
    revisorCi() {
      return this.solicitudData?.revisandoPor?.nroCi || '-';
    },
    fechaSolicitud() {
      return formatearFechaHoraBolivia(this.solicitudData?.fechaSolicitud);
    },
    tipoLabel() {
      const tipo = this.solicitudData?.tipoSolicitud;
      return this.tiposSolicitud[tipo] || tipo || '-';
    },
    subtitle() {
      if (!this.solicitudData) {
        return 'Detalle de solicitud';
      }

      const programa = this.programaCodigo !== '-' ? `Programa ${this.programaCodigo}` : '';
      const modulo = this.moduloNumero !== '-' ? `Módulo ${this.moduloNumero}` : '';

      return [programa, modulo].filter(Boolean).join(' · ') || 'Detalle de solicitud';
    },
  },
  methods: {
    abrir(solicitud) {
      this.solicitudData = solicitud || null;
      this.dialog = true;
      this.observacion = this.solicitudData?.observaciones || '';
      this.cargarSolicitudPDF();
    },
    async cargarSolicitudPDF() {
      if (!this.solicitudData?.id) {
        this.limpiarPdf();
        return;
      }

      this.cargandoPdf = true;
      this.pdfError = null;
      this.limpiarPdfUrl();

      try {
        const { data, headers } = await solicitudModificacionCalificacionService.verSolicitudPDF(this.solicitudData.id);
        const contentType = headers?.['content-type'] || 'application/pdf';
        const blob = new Blob([data], { type: contentType });

        this.pdfUrl = URL.createObjectURL(blob);
      } catch (error) {
        const mensaje = error?.response?.data?.mensaje || 'No se pudo cargar el PDF de la solicitud.';
        this.pdfError = mensaje;
      } finally {
        this.cargandoPdf = false;
      }
    },

    async revisarSolicitud(estado) {
      if (!this.solicitudData?.id) {
        return;
      }

      const revisarSolicitudInput = {
        solicitudId: this.solicitudData.id,
        estado,
      };
      if(estado !== ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.APROBADA){
        revisarSolicitudInput.motivo = this.observacion;
      }
      try {
        const { data } = await solicitudModificacionCalificacionService.revisarSolicitud(revisarSolicitudInput);
        const mensaje = data?.mensaje || 'Solicitud revisada correctamente';
        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: mensaje,
          type: 'success',
        });
        
      // eslint-disable-next-line no-console
        console.log('Solicitud revisada', mensaje);
        this.$emit('solicitud-revisada', revisarSolicitudInput);
        this.cerrar();
      } catch (error) {
        // const mensaje = error?.response?.data?.mensaje || 'No se pudo revisar la solicitud.';

          // this.$notify({
          //   group: 'notifications',
          //   title: 'Error',
          //   text: mensaje,
          //   type: 'error',
          // });
        // // eslint-disable-next-line no-console
        // console.error(mensaje);
      } finally {
        this.cargandoPdf = false;
      }
    },
    async confirmarRevisar(estado) {
      const acciones = {
        aprobada: 'aprobar',
        rechazada: 'rechazar',
        observado: 'observar',
      };

      this.confirmacionDialog.estado = estado;
      this.confirmacionDialog.accionLabel = acciones[estado] || 'continuar';
      this.confirmacionDialog.colorClass = {
        aprobada: 'confirm-card__icon--success',
        rechazada: 'confirm-card__icon--error',
        observado: 'confirm-card__icon--warning',
      }[estado] || '';
      this.confirmacionDialog.icono = {
        aprobada: 'mdi-check-circle-outline',
        rechazada: 'mdi-close-circle-outline',
        observado: 'mdi-alert-circle-outline',
      }[estado] || 'mdi-help-circle-outline';
      this.confirmacionDialog.abierto = true;
    },
    async ejecutarRevisionConfirmada() {
      const estado = this.confirmacionDialog.estado;

      this.confirmacionDialog.abierto = false;

      if (!estado) {
        return;
      }

      await this.revisarSolicitud(estado);
    },
    cerrar() {
      this.dialog = false;

      this.limpiarPdf();
    },
    limpiarPdf() {
      this.pdfError = null;
      this.cargandoPdf = false;
      this.limpiarPdfUrl();
    },
    limpiarPdfUrl() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }

      this.pdfUrl = null;
    },
  },
};
</script>

<style scoped>
.title {
  font-weight: 600;
}

.muted {
  color: #6a6f7a;
}

.dialog-card {
  border-radius: 10px;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.dialog-card .v-card-text {
  flex: 1;
  overflow-y: auto;
}

.hero {
  padding: 14px 20px;
  background: linear-gradient(135deg, #f6f8fb, #eef2f7);
  border-bottom: 1px solid #e5e8ec;
}

.hero-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hero .title {
  font-size: 20px;
}

.hero .muted {
  font-size: 13px;
}

.field-label {
  display: block;
  font-size: 12px;
  color: #7d8894;
  margin-bottom: 4px;
}

.field-value {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 2px;
}

.section {
  margin-top: 8px;
}

.section-title {
  font-weight: 600;
  margin-bottom: 2px;
}

.section-text {
  margin: 0;
  color: #444b55;
}

.body-wrapper {
  background: var(--v-primary-lighten6, #f3f7ff);
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  background: var(--v-primary-lighten6, #e8f1ff);
  border-color: var(--v-primary-lighten4, #d6e6ff);
  box-shadow: 0 1px 4px rgba(17, 24, 39, 0.06);
  border-radius: 12px;
}

.stat-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.icon-purple {
  background: var(--v-primary-lighten5, #d9e9ff);
  color: var(--v-primary-base, #1976d2);
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 12px;
  color: #6a6f7a;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 2px;
}

.stat-value {
  font-weight: 700;
  font-size: 15px;
  color: #2b2f38;
}

.text-card {
  padding: 14px 16px;
  background: var(--v-primary-lighten6, #f0f6ff);
  border-color: var(--v-primary-lighten6, #d6e6ff);
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(17, 24, 39, 0.05);
}

.text-card__title {
  font-weight: 700;
  margin-bottom: 6px;
  color: #343a40;
}

.text-card__body {
  margin: 0;
  color: #444b55;
}

.pdf-card {
  margin-top: 12px;
  padding: 14px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(17, 24, 39, 0.05);
}

.pdf-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}


.pdf-card__body {
  border: 1px dashed #d6e6ff;
  border-radius: 10px;
  padding: 8px;
  background: var(--v-primary-lighten6, #f7faff);
  height: calc(100vh - 365px);
}

.pdf-frame-wrapper {
  height: 100%;
  min-height: 320px;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.pdf-frame-wrapper iframe {
  border: none;
}

.pdf-skeleton {
  height: 520px;
}

.info-grid {
  margin-bottom: 12px;
}

.confirm-card {
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.confirm-card__header {
  display: flex;
  align-items: center;
  padding: 18px 18px 10px;
}

.confirm-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  background: #e5e7eb;
  color: #111827;
}

.confirm-card__icon--success {
  background: rgba(46, 204, 113, 0.14);
  color: #2ecc71;
}

.confirm-card__icon--error {
  background: rgba(231, 76, 60, 0.14);
  color: #e74c3c;
}

.confirm-card__icon--warning {
  background: rgba(241, 196, 15, 0.18);
  color: #f1c40f;
}

.confirm-card__title {
  font-weight: 700;
  font-size: 18px;
  color: #1f2937;
}

.confirm-card__subtitle {
  font-size: 13px;
  color: #6b7280;
}

.confirm-card__body {
  padding: 4px 18px 0;
  color: #374151;
  font-size: 14px;
}

.confirm-card__actions {
  padding: 12px 18px 16px;
  justify-content: flex-end;
}
</style>
